import {connect} from "react-redux";
import Penalty from "./Penalty";
import {bindActionCreators} from "redux";
import {getInactiveFsesRequest, tollById, getFseActivationCheckRequest, callLogsRequest, tollPendingMeetingRequest,nearestPlazaFromOperatorLocationRequest} from "../../../../service/FasttagToll/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    getInactiveFsesResponse:state.FasttagToll.getInactiveFsesResponse,
    tollView:state.FasttagToll.tollView,
    getFseActivationCheckResponse:state.FasttagToll.getFseActivationCheckResponse,
    callLogsResponse:state.FasttagToll.callLogsResponse,
    tollPendingMeetingResponse:state.FasttagToll.tollPendingMeetingResponse,
    nearestPlazaFromOperatorLocationResponse:state.FasttagToll.nearestPlazaFromOperatorLocationResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInactiveFsesRequest,
            tollById,
            getFseActivationCheckRequest,
            callLogsRequest,
            tollPendingMeetingRequest,
            documentUploadUrlPublic,
            nearestPlazaFromOperatorLocationRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Penalty);
